import { useLocation } from "react-router";

/**
 * Shared "is this a Learning Center route?" predicate (SFCC-11508 / TPA).
 *
 * Port of hec-composable `hec/hooks/learning-center/useIsLearningCenter.tsx`:
 * true when the current pathname has a `learning-center` segment. Extracted so
 * the TPA consent-modal guard, the nav tracker, and analytics all share ONE
 * definition instead of each re-deriving it (the nav tracker previously kept a
 * private `isLearningCenterPath`; it now delegates to `isLearningCenterPath`
 * exported here for its `prev`-path transition checks).
 *
 * Hook form for component/guard consumers; the bare `isLearningCenterPath`
 * helper is exported for callers that already hold a pathname string (e.g. the
 * nav tracker comparing the previous path).
 */
export const isLearningCenterPath = (pathname: string): boolean =>
  pathname.split("/").includes("learning-center");

export function useIsLearningCenter(): boolean {
  const { pathname } = useLocation();
  return isLearningCenterPath(pathname);
}
